import { Themed } from '@theme-ui/mdx';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import { Box, Button, Container } from 'theme-ui';

import CirclesPurpleIcon from '@src/assets/icons/circles-purple.svg';
import TeacherCard from '@src/components/teacherCard';

import './feedbackSection.scss';

const teacherSection = ({ title, teachers, bgColor, linkToTeachersPage }) => {
  const { t, i18n } = useTranslation();
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    speed: 500,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1000000,
        settings: 'unslick',
      },
    ],
  };
  return (
    <>
      {teachers && teachers.length > 0 && (
        <Box className="relative">
          <Box
            bg={bgColor}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              zIndex: '-1',
            }}
          ></Box>
          <CirclesPurpleIcon className="circle-bottom-right circle-green" />
          <Container px={4} pt={6} sx={{ position: 'relative' }}>
            <>
              <Themed.h2 sx={{ textAlign: 'center' }}>{title}</Themed.h2>

              <Slider className="slider--desktop-3-columns" {...sliderSettings}>
                {teachers.map((item) => (
                  <TeacherCard key={item.id} teacher={item} />
                ))}
              </Slider>
            </>
          </Container>
          <Box
            sx={{
              textAlign: 'center',
              paddingBottom: 6,
              position: 'relative',
              zIndex: '1',
            }}
          >
            <Link to={`${linkToTeachersPage}`}>
              <Button>{t('allTeachers')}</Button>
            </Link>
          </Box>
        </Box>
      )}
    </>
  );
};

export default teacherSection;
